/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setyourbusinessoperatinghours4Inputs */

const en_setyourbusinessoperatinghours4 = /** @type {(inputs: Setyourbusinessoperatinghours4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set your business operating hours`)
};

const de_setyourbusinessoperatinghours4 = /** @type {(inputs: Setyourbusinessoperatinghours4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leg deine Öffnungszeiten fest`)
};

/**
* | output |
* | --- |
* | "Set your business operating hours" |
*
* @param {Setyourbusinessoperatinghours4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const setyourbusinessoperatinghours4 = /** @type {((inputs?: Setyourbusinessoperatinghours4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setyourbusinessoperatinghours4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_setyourbusinessoperatinghours4(inputs)
	return de_setyourbusinessoperatinghours4(inputs)
});
export { setyourbusinessoperatinghours4 as "setYourBusinessOperatingHours" }